import React from "react";
import { AiOutlineExclamation } from "react-icons/ai";
import TextField from "@mui/material/TextField";
import { useSearchParams } from "react-router-dom";
import useResetPasswordForm from "hooks/auth/useResetPasswordForm";
import { MODES } from "./constants";

const ResetPassword = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { values, errors, submitForm, setFieldValue } = useResetPasswordForm();

  return (
    <div className="flex flex-col gap-[18px] p-[24px] rounded-[24px] bg-[#EDF1FF] w-full">
      <div className="flex flex-col gap-[8px] w-fit">
        <span className="text-[32px] font-[700] text-[#212121] leading-none tracking-[-1.28px]">
          Մոռացե՞լ եք գաղտնաբառը
        </span>
        <div className="w-full border-b border-[#6685FF]" />
      </div>
      <TextField
        placeholder="Էլ․ հասցե"
        type="email"
        sx={{
          backgroundColor: "white",
          borderRadius: "14px",
          "& fieldset": { border: "none" },
        }}
        value={values.email}
        onChange={(e) => setFieldValue("email", e.target.value)}
      />

      <div className="flex justify-start items-center p-[12px] gap-[10px] bg-white rounded-[14px]">
        <div className="w-[40px] h-[40px] flex items-center justify-center rounded-[12px] bg-[#EDF1FF]">
          <AiOutlineExclamation />
        </div>
        <span className="text-[14px] w-fit">
          Մենք ձեզ կուղարկենք հղում, գաղտնաբառը վերականգնելու համար
        </span>
      </div>

      <button
        onClick={() => submitForm()}
        className="bg-[#03F] rounded-[14px] text-white text-[16px] font-[700] flex items-center justify-center px-[24px] h-[60px] cursor-pointer"
      >
        <span>Վերականգնել</span>
      </button>
      {Boolean(errors.email) && (
        <div className="flex justify-start items-center p-[12px] gap-[10px] bg-white rounded-[14px]">
          <div className="w-[40px] h-[40px] flex items-center justify-center rounded-[12px] text-[#FF0074] bg-[#FFE3F0]">
            <AiOutlineExclamation />
          </div>
          <span className="text-[14px] w-fit">{errors.email}</span>
        </div>
      )}
      <div className="flex items-center justify-center gap-[18px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="81"
          height="1"
          viewBox="0 0 81 1"
          fill="none"
        >
          <path
            d="M0.683594 0.5H80.5001"
            stroke="#6685FF"
            stroke-linecap="round"
          />
        </svg>
        <span className="text-[#6685FF] text-[14px]">կամ</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="81"
          height="1"
          viewBox="0 0 81 1"
          fill="none"
        >
          <path
            d="M0.683594 0.5H80.5001"
            stroke="#6685FF"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div className="flex justify-center">
        <div className="p-[12px] flex items-center gap-[12px] bg-white rounded-[24px]">
          <div className="flex items-center justify-center bg-[#EDF1FF] rounded-[12px] p-[8px] cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M17.5 4H15.5C13 4 11.5 5.5 11.5 8V20"
                stroke="#6685FF"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.5 12H15.5"
                stroke="#6685FF"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="flex items-center justify-center bg-[#EDF1FF] rounded-[12px] p-[8px] cursor-pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M21.85 11.1H12.68V13.83H19.19C18.86 17.64 15.69 19.27 12.69 19.27C8.86003 19.27 5.50003 16.25 5.50003 12C5.50003 7.9 8.70003 4.73 12.7 4.73C15.79 4.73 17.6 6.7 17.6 6.7L19.5 4.72C19.5 4.72 17.06 2 12.6 2C6.92003 2 2.53003 6.8 2.53003 12C2.53003 17.05 6.66003 22 12.75 22C18.1 22 22 18.33 22 12.91C22 11.76 21.85 11.1 21.85 11.1Z"
                fill="#6685FF"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center gap-[18px]">
        <span className="text-[12px] md:text-[16px] font-[400]">
          գրանցված է՞ք
        </span>
        <button
          style={{ boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.05)" }}
          className="flex items-center justify-center px-[28px] py-[8px] rounded-[80px] bg-white h-[60px] cursor-pointer text-center"
          onClick={() => {
            searchParams.set("mode", MODES.REGISTRATION);
            setSearchParams(searchParams, { replace: true });
          }}
        >
          <span className="text-[#03F] text-[12px] md:text-[16px] font-[700]">
            Մուտք գործել
          </span>
        </button>
      </div>
    </div>
  );
};

export default ResetPassword;
